import { DatabaseEntities } from './base';
import { Nullable } from './globals';

export enum UnitType {
  Appointment = 'Appointment',
  Units = 'Units'
}

export enum UnitGrouper {
  LoadType = DatabaseEntities.LoadType,
  Dock = DatabaseEntities.Dock,
  Warehouse = DatabaseEntities.Warehouse,
  LoadTypeGroup = DatabaseEntities.LoadTypeGroup
}

export interface IUnitLimit {
  loadTypes: string[] | null | undefined;

  // general liimits
  dailyLimit: Nullable<number>;
  weeklyLimit: Nullable<number>;
  monthlyLimit: Nullable<number>;

  // specific weekdays limits
  mondayLimit: Nullable<number>;
  tuesdayLimit: Nullable<number>;
  wednesdayLimit: Nullable<number>;
  thursdayLimit: Nullable<number>;
  fridayLimit: Nullable<number>;
  saturdayLimit: Nullable<number>;
  sundayLimit: Nullable<number>;

  // specific months limits
  januaryLimit: Nullable<number>;
  februaryLimit: Nullable<number>;
  marchLimit: Nullable<number>;
  aprilLimit: Nullable<number>;
  mayLimit: Nullable<number>;
  juneLimit: Nullable<number>;
  julyLimit: Nullable<number>;
  augustLimit: Nullable<number>;
  septemberLimit: Nullable<number>;
  octoberLimit: Nullable<number>;
  novemberLimit: Nullable<number>;
  decemberLimit: Nullable<number>;
}
